import '@root/lib/vite/plugins/rails-full-reload/client'
import { application } from '@/controllers'
import { refreshRecaptchaV3OnSubmit } from '@/utils/recaptcha_v3_refresh'

// Google expires a v3 token two minutes after the page mints it
refreshRecaptchaV3OnSubmit()

// Use the date picker on every page
import DatePickerController from '@/controllers/date_picker_controller'
application.register('date-picker', DatePickerController)

// Use the search controller on every page
import SearchController from '@/controllers/search_controller'
application.register('search', SearchController)

// Use the checkbox controller on every page
import CheckboxController from '@/controllers/checkbox_controller'
application.register('checkbox', CheckboxController)

// Use the choices controller on every page
import ChoicesController from '@/controllers/choices_controller'
application.register('choices', ChoicesController)

// Backs the ux-admin-single-select decision surface
import SingleSelectRevealController from '@/controllers/single_select_reveal_controller'
application.register('single-select-reveal', SingleSelectRevealController)

import AutoSubmitFormController from '@/controllers/auto_submit_form_controller'
application.register('auto-submit-form', AutoSubmitFormController)

import FocusTrapController from '@/controllers/focus_trap_controller'
application.register('focus-trap', FocusTrapController)

import SpacebarLinkController from '@/controllers/spacebar_link_controller'
application.register('spacebar-link', SpacebarLinkController)

import FormErrorsController from '@/controllers/form_errors_controller'
application.register('form-error', FormErrorsController)

import FlashAlertController from '@/controllers/flash_alert_controller'
application.register('flash-alert', FlashAlertController)

import CheckboxSelectorController from '@/controllers/checkbox_selector_controller'
application.register('checkbox-selector', CheckboxSelectorController)

import NumberFieldButtonsController from '@/controllers/number_field_buttons_controller'
application.register('number-field-buttons', NumberFieldButtonsController)

import QRCodeReaderController from '@/controllers/qr_code_reader_controller'
application.register('qr-code-reader', QRCodeReaderController)

import AiCaptionController from '@/controllers/ai_caption_controller'
application.register('ai-caption', AiCaptionController)

import LineChartController from '@/controllers/line_chart_controller'
application.register('line-chart', LineChartController)

import FileUploadController from '@/controllers/file_upload_controller'
application.register('file-upload', FileUploadController)

import FileUploadUiController from '@/controllers/file_upload_ui_controller'
application.register('file-upload-ui', FileUploadUiController)

import CookiesController from '@/controllers/cookies_controller'
application.register('cookies', CookiesController)

import StickyHeaderController from '@/controllers/sticky_header_controller'
application.register('sticky-header', StickyHeaderController)

import TooltipHoverController from '@/controllers/tooltip_hover_controller'
application.register('tooltip-hover', TooltipHoverController)

import MobileNumberValidationController from '@/controllers/mobile_number_validation_controller'
application.register(
  'mobile-number-validation',
  MobileNumberValidationController,
)

import ProductGroupController from '@/controllers/orders/product_group_controller'
application.register('product-group', ProductGroupController)

import ProductQuestionsController from '@/controllers/orders/product_questions_controller'
application.register('product-questions', ProductQuestionsController)

import CollapsibleController from '@/controllers/collapsible_controller'
application.register('collapsible', CollapsibleController)

import FileSizeValidationController from '@/controllers/file_size_validation_controller'
application.register('file-size-validation', FileSizeValidationController)

import ExpireCartController from '@/controllers/orders/expire_cart_controller'
application.register('expire-cart', ExpireCartController)

import AuthorizeNetCheckoutController from '@/controllers/orders/authorize_net_checkout_controller'
application.register('authorize-net-checkout', AuthorizeNetCheckoutController)

import PaginatedFormController from '@/controllers/forms/paginated_form_controller'
application.register('paginated-form', PaginatedFormController)

import ClientSideValidationController from '@/controllers/forms/client_side_validation_controller'
application.register('client-side-validation', ClientSideValidationController)

import UserSupportController from '@/controllers/user_support_controller'
application.register('user-support', UserSupportController)

import TurboRestoreController from '@/controllers/turbo_restore_controller'
application.register('turbo-restore', TurboRestoreController)

import UrlUpdaterController from '@/controllers/url_updater_controller'
application.register('url-updater', UrlUpdaterController)

import ChecklistController from '@/controllers/checklist_controller'
application.register('checklist', ChecklistController)

import ExpandableSectionController from '@/controllers/expandable_section_controller'
application.register('expandable-section', ExpandableSectionController)

import AwsWafFormController from '@/controllers/aws_waf_form_controller'
application.register('aws-waf-form', AwsWafFormController)

import AccessAuthController from '@/controllers/access_auth_controller'
application.register('access-auth', AccessAuthController)

import EmailFirstController from '@/controllers/email_first_controller'
application.register('email-first', EmailFirstController)

import JoinFormController from '@/controllers/join_form_controller'
application.register('join-form', JoinFormController)

import LoginCodeController from '@/controllers/login_code_controller'
application.register('login-code', LoginCodeController)

import MfaSmsCodeController from '@/controllers/mfa_sms_code_controller'
application.register('mfa-sms-code', MfaSmsCodeController)

import FilterFormController from '@/controllers/filter_form_controller'
application.register('filter-form', FilterFormController)

console.log('Loaded application_es6.js')
